import React from "react";
import Login from "./Login";
import Results from "./Results"
import Search from "./Search";
import RequestFiles from "./RequestFiles";
import Email from "./Email";
import ResetPassword from "./ResetPassword";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { Auth } from "aws-amplify";
import { withAuthenticator } from "aws-amplify-react";
import { LuiHeader, LuiFooter, LuiHeaderMenuItem } from "@linzjs/lui";

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      signedIn: false
    };

    this.handleSignIn = this.handleSignIn.bind(this)
  }

  componentDidMount() {
    this.checkSignedIn();
    const thisCheckSignedIn = this.checkSignedIn.bind(this);
    this.checkSignedInInterval = setInterval(thisCheckSignedIn, 60000);
  }

  checkSignedIn() {
    Auth.currentAuthenticatedUser().then(() => {
      this.setState({signedIn: true});
    }).catch(() => {
      this.setState({signedIn: false});
    });
  }

  componentWillUnmount() {
    clearInterval(this.checkSignedInInterval);
  }

  handleSignIn() {
    this.setState({
      signedIn: true
    })
  }

  handleLogout() {
    Auth.signOut().then(() => {
      this.setState({signedIn: false});
    })
  }

  redirectRoute(component) {
    return this.state.signedIn ? component : <Redirect to="/" />;
  }

  render() {
    const signedIn = this.state.signedIn;
    return (
      <>
        <LuiHeader size="normal" headingText="ELFI" >
          {
            signedIn && <LuiHeaderMenuItem icon="person" label="Logout" onClick={this.handleLogout.bind(this)} />
          }
        </LuiHeader>
        <div className="g-flex-container lui-margin-top-md lui-margin-bottom-xl">
          <Router>
            <div>
              <Switch>
                <Route path="/search">
                  {this.redirectRoute(<Search/>)}
                </Route>
                <Route path="/results">
                  {this.redirectRoute(<Results/>)}
                </Route>
                <Route path="/request">
                  {this.redirectRoute(<RequestFiles/>)}
                </Route>
                <Route path="/email">
                  {this.redirectRoute(<Email/>)}
                </Route>
                <Route path="/ResetPassword" component={withAuthenticator(ResetPassword)} />
                <Route exact path="/">
                  {signedIn ? <Redirect to="/search" /> : <Login handleSignIn={this.handleSignIn} />}
                </Route>
              </Switch>
            </div>
          </Router>
        </div>
        <LuiFooter
          footerText="LINZ ELFI"
          contactNumber="04 555 9856"
          contactEmail="sample@email.com"
          feedbackFormUrl="http://sample.com"
        />
      </>
    );
  }
}

export default App;
